import { Injectable } from '@angular/core';
import { injectGlobal } from '@emotion/css';
import { defaultColorsValues, defaultColorsValuesDark } from 'na-lib';
import { UploadService } from './upload.service';
import { environment } from 'src/environments/environment';
import { CommentsService } from './comments.service';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root'
})
export class DppThemeService {

  defaultColorsValues = defaultColorsValues
  defaultColorsValuesDark = defaultColorsValuesDark
  urlFonts:any = {}
  idToShow:any
  
  constructor( private uploadService: UploadService,
    private commentService: CommentsService,
    private settingsService: SettingsService ) { }

  setWidgetSpacingCornerRadius(theme){
    if(theme){
      if(theme.widgetSpacing)
        document.documentElement.style.setProperty('--widgetSpacing',theme.widgetSpacing+'px')
      else if(theme.widgetSpacing === 0)
        document.documentElement.style.setProperty('--widgetSpacing','0')
      else
        document.documentElement.style.setProperty('--widgetSpacing','20px')

      if(theme.cornerRadius)
        document.documentElement.style.setProperty('--cornerRadius',theme.cornerRadius+'px')
      else if(theme.cornerRadius === 0)
        document.documentElement.style.setProperty('--cornerRadius','0')
      else
        document.documentElement.style.setProperty('--cornerRadius','10px')
      
    }else{
      document.documentElement.style.setProperty('--cornerRadius','10px')
      document.documentElement.style.setProperty('--widgetSpacing','20px')
    }
  }

  setColorsToDark(themeData ){

    if(themeData && themeData['darkColors']){
      if(themeData['darkColors'].accent)
        document.documentElement.style.setProperty('--accent',themeData['darkColors'].accent)
      else
        document.documentElement.style.setProperty('--accent',this.defaultColorsValuesDark.accent)

      if(themeData['darkColors'].background)
        document.documentElement.style.setProperty('--background', themeData['darkColors'].background)
      else
        document.documentElement.style.setProperty('--background',this.defaultColorsValuesDark.background)

      if(themeData['darkColors'].title)
        document.documentElement.style.setProperty('--title', themeData['darkColors'].title)
      else
        document.documentElement.style.setProperty('--title',this.defaultColorsValuesDark.title)

      if(themeData['darkColors'].subtitle)
        document.documentElement.style.setProperty('--subtitle',themeData['darkColors'].subtitle)
      else
        document.documentElement.style.setProperty('--subtitle',this.defaultColorsValuesDark.subtitle)

      if(themeData['darkColors'].primary)
        document.documentElement.style.setProperty('--primary',themeData['darkColors'].primary)
        else
        document.documentElement.style.setProperty('--primary',this.defaultColorsValuesDark.primary)

      if(themeData['darkColors'].secondary)
        document.documentElement.style.setProperty('--secondary',themeData['darkColors'].secondary)
      else
        document.documentElement.style.setProperty('--secondary',this.defaultColorsValuesDark.secondary)
    
    } else {
      document.documentElement.style.setProperty('--accent',this.defaultColorsValuesDark.accent)
      document.documentElement.style.setProperty('--background',this.defaultColorsValuesDark.background)
      document.documentElement.style.setProperty('--title',this.defaultColorsValuesDark.title)
      document.documentElement.style.setProperty('--subtitle',this.defaultColorsValuesDark.subtitle)
      document.documentElement.style.setProperty('--primary',this.defaultColorsValuesDark.primary)
      document.documentElement.style.setProperty('--secondary',this.defaultColorsValuesDark.secondary)
    }
  }

  setColorsToLight(themeData){
    if(themeData && themeData['lightColors']){
      if(themeData['lightColors'].accent)
        document.documentElement.style.setProperty('--accent', themeData['lightColors'].accent)
      else
        document.documentElement.style.setProperty('--accent',this.defaultColorsValues.accent)

      if(themeData['lightColors'].background)
        document.documentElement.style.setProperty('--background', themeData['lightColors'].background)
      else
        document.documentElement.style.setProperty('--background',this.defaultColorsValues.background)

      if(themeData['lightColors'].title)
        document.documentElement.style.setProperty('--title', themeData['lightColors'].title)
      else
        document.documentElement.style.setProperty('--title',this.defaultColorsValues.title)

      if(themeData['lightColors'].subtitle)
        document.documentElement.style.setProperty('--subtitle', themeData['lightColors'].subtitle)
      else
        document.documentElement.style.setProperty('--subtitle',this.defaultColorsValues.subtitle)

      if(themeData['lightColors'].primary)
        document.documentElement.style.setProperty('--primary', themeData['lightColors'].primary)
      else
        document.documentElement.style.setProperty('--primary',this.defaultColorsValues.primary)

      if(themeData['lightColors'].secondary)
        document.documentElement.style.setProperty('--secondary', themeData['lightColors'].secondary)
      else
        document.documentElement.style.setProperty('--secondary',this.defaultColorsValues.secondary)

    } else {
      document.documentElement.style.setProperty('--accent',this.defaultColorsValues.accent)
      document.documentElement.style.setProperty('--background',this.defaultColorsValues.background)
      document.documentElement.style.setProperty('--title',this.defaultColorsValues.title)
      document.documentElement.style.setProperty('--subtitle',this.defaultColorsValues.subtitle)
      document.documentElement.style.setProperty('--primary',this.defaultColorsValues.primary)
      document.documentElement.style.setProperty('--secondary',this.defaultColorsValues.secondary)
    }
  }

  fontsToDefault(){
    // title
    document.documentElement.style.setProperty('--titleFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--titleFontUrl',"")
    document.documentElement.style.setProperty('--titleFontUrlsrc',"")

    //subtitle
    document.documentElement.style.setProperty('--subtitleFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--subtitleFontUrl',"")
    document.documentElement.style.setProperty('--subtitleFontUrlsrc',"")

    // plain
    document.documentElement.style.setProperty('--plainFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--plainFontUrl',"")
    document.documentElement.style.setProperty('--plainFontUrlsrc',"")

    // bold
    document.documentElement.style.setProperty('--boldFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--boldFontUrl',"")
    document.documentElement.style.setProperty('--boldFontUrlsrc',"")

    // italic
    document.documentElement.style.setProperty('--italicFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--italicFontUrl',"")
    document.documentElement.style.setProperty('--italicFontUrlsrc',"")

    injectGlobal`#title {font-family: var(--titleFontName);}`
    injectGlobal`#subtitle {font-family: var(--subtitleFontName);}`
    injectGlobal`#plain {font-family: var(--plainFontName);}`
    injectGlobal`#italic {font-family: var(--italicFontName);}`
    injectGlobal`#bold {font-family: var(--boldFontName);}`
  }

  updateColors(themeData){
    if(themeData && themeData['lightColors']){
      if(themeData['lightColors'].accent)
        document.documentElement.style.setProperty('--accentLight', themeData['lightColors'].accent)
      if(themeData['lightColors'].background)
        document.documentElement.style.setProperty('--backgroundLight', themeData['lightColors'].background)
      if(themeData['lightColors'].title)
        document.documentElement.style.setProperty('--titleLight', themeData['lightColors'].title)
      if(themeData['lightColors'].subtitle)
        document.documentElement.style.setProperty('--subtitleLight', themeData['lightColors'].subtitle)
      if(themeData['lightColors'].primary)
        document.documentElement.style.setProperty('--primaryLight', themeData['lightColors'].primary)
      if(themeData['lightColors'].secondary)
        document.documentElement.style.setProperty('--secondaryLight', themeData['lightColors'].secondary)
    }else{
      this.colorsToDefaultLight()
    }
  }

  updateColorsDark(themeData){
    if(themeData && themeData['darkColors']){
      if(themeData['darkColors'].accent)
        document.documentElement.style.setProperty('--accentDark', themeData['darkColors'].accent)
      if(themeData['darkColors'].background)
        document.documentElement.style.setProperty('--backgroundDark', themeData['darkColors'].background)
      if(themeData['darkColors'].title)
        document.documentElement.style.setProperty('--titleDark', themeData['darkColors'].title)
      if(themeData['darkColors'].subtitle)
        document.documentElement.style.setProperty('--subtitleDark', themeData['darkColors'].subtitle)
      if(themeData['darkColors'].primary)
        document.documentElement.style.setProperty('--primaryDark', themeData['darkColors'].primary)
      if(themeData['darkColors'].secondary)
        document.documentElement.style.setProperty('--secondaryDark', themeData['darkColors'].secondary)
    }else{
      this.colorsToDefaultDark()
    }
  }

  colorsToDefault(){
    for (const key in this.defaultColorsValues) {
      document.documentElement.style.setProperty('--' + key, this.defaultColorsValues[key]);
    }
  }

  colorsToDefaultDark(){
    document.documentElement.style.setProperty('--accentDark',this.defaultColorsValuesDark.accent)
    document.documentElement.style.setProperty('--backgroundDark',this.defaultColorsValuesDark.background)
    document.documentElement.style.setProperty('--titleDark',this.defaultColorsValuesDark.title)
    document.documentElement.style.setProperty('--subtitleDark',this.defaultColorsValuesDark.subtitle)
    document.documentElement.style.setProperty('--primaryDark',this.defaultColorsValuesDark.primary)
    document.documentElement.style.setProperty('--secondaryDark',this.defaultColorsValuesDark.secondary)
  }

  colorsToDefaultLight(){
    document.documentElement.style.setProperty('--accentLight',this.defaultColorsValues.accent)
    document.documentElement.style.setProperty('--backgroundLight',this.defaultColorsValues.background)
    document.documentElement.style.setProperty('--titleLight',this.defaultColorsValues.title)
    document.documentElement.style.setProperty('--subtitleLight',this.defaultColorsValues.subtitle)
    document.documentElement.style.setProperty('--primaryLight',this.defaultColorsValues.primary)
    document.documentElement.style.setProperty('--secondaryLight',this.defaultColorsValues.secondary)
  }


  restoreFonts(){
    this.uploadService.emptyFonts()
    
    // title
    document.documentElement.style.setProperty('--titleFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--titleFontUrl',"")
    document.documentElement.style.setProperty('--titleFontUrlsrc',"")

    //subtitle
    // document.documentElement.style.removeProperty('subtitle')
    document.documentElement.style.setProperty('--subtitleFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--subtitleFontUrl',"")
    document.documentElement.style.setProperty('--subtitleFontUrlsrc',"")

    // plain
    // document.documentElement.style.removeProperty('plain')
    document.documentElement.style.setProperty('--plainFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--plainFontUrl',"")
    document.documentElement.style.setProperty('--plainFontUrlsrc',"")

    // bold
    // document.documentElement.style.removeProperty('bold')
    document.documentElement.style.setProperty('--boldFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--boldFontUrl',"")
    document.documentElement.style.setProperty('--boldFontUrlsrc',"")

    // italic
    // document.documentElement.style.removeProperty('italic')
    document.documentElement.style.setProperty('--italicFontName',"'Roboto', sans-serif")
    document.documentElement.style.setProperty('--italicFontUrl',"")
    document.documentElement.style.setProperty('--italicFontUrlsrc',"")

    if(document.getElementById('title'))
      document.getElementById('title').style.fontFamily = "'Roboto', sans-serif"

    if(document.getElementById('subtitle'))
      document.getElementById('subtitle').style.fontFamily = "'Roboto', sans-serif"

    if(document.getElementById('plain'))
      document.getElementById('plain').style.fontFamily = "'Roboto', sans-serif"

    if(document.getElementById('bold'))
      document.getElementById('bold').style.fontFamily = "'Roboto', sans-serif"

    if(document.getElementById('italic'))
      document.getElementById('italic').style.fontFamily = "'Roboto', sans-serif"

    injectGlobal`#title {font-family: var(--titleFontName);}`
    injectGlobal`#subtitle {font-family: var(--subtitleFontName);}`
    injectGlobal`#plain {font-family: var(--plainFontName);}`
    injectGlobal`#italic {font-family: var(--italicFontName);}`
    injectGlobal`#bold {font-family: var(--boldFontName);}`
  }


  updateFonts(themeData){
    if(themeData && themeData['fonts']){
      if(themeData['fonts'].title && themeData['fonts'].title.name && themeData['fonts'].title.url ){
        this.supportUrl(themeData,themeData['fonts'].title.url, 'title')
      }else{
        if(document.getElementById('title')){
          document.getElementById('title').style.fontFamily = "'Roboto', sans-serif"
        }else{
          injectGlobal`
            #title {
              font-family: 'Roboto', sans-serif;
            }
          `
        }
        // title
        document.documentElement.style.setProperty('--titleFontName',"'Roboto', sans-serif")
        document.documentElement.style.setProperty('--titleFontUrl',"")
        document.documentElement.style.setProperty('--titleFontUrlsrc',"")
      }

      if(themeData['fonts'].subtitle && themeData['fonts'].subtitle.name && themeData['fonts'].subtitle.url ){
        this.supportUrl(themeData, themeData['fonts'].subtitle.url, 'subtitle')
      }else{
        if(document.getElementById('subtitle')){
        document.getElementById('subtitle').style.fontFamily = "'Roboto', sans-serif"
        }else{
        injectGlobal`
          #subtitle {
            font-family: 'Roboto', sans-serif;
          }
        `}
        //subtitle
        document.documentElement.style.setProperty('--subtitleFontName',"'Roboto', sans-serif")
        document.documentElement.style.setProperty('--subtitleFontUrl',"")
        document.documentElement.style.setProperty('--subtitleFontUrlsrc',"")
      }

      if(themeData['fonts'].plain && themeData['fonts'].plain.name && themeData['fonts'].plain.url ){
        this.supportUrl(themeData, themeData['fonts'].plain.url, 'plain')
      }else{

        if(document.getElementById('plain')){
          document.getElementById('plain').style.fontFamily = "'Roboto', sans-serif"
          }else{
        injectGlobal`
          #plain {
            font-family: 'Roboto', sans-serif;
          }
        `}
        // plain
        document.documentElement.style.setProperty('--plainFontName',"'Roboto', sans-serif")
        document.documentElement.style.setProperty('--plainFontUrl',"")
        document.documentElement.style.setProperty('--plainFontUrlsrc',"")
      }

      if(themeData['fonts'].bold && themeData['fonts'].bold.name && themeData['fonts'].bold.url ){
        this.supportUrl(themeData, themeData['fonts'].bold.url, 'bold')
      }else{
        if(document.getElementById('bold')){
          document.getElementById('bold').style.fontFamily = "'Roboto', sans-serif"
          }else{
        injectGlobal`
          #bold {
            font-family: 'Roboto', sans-serif;
          }
        `}
        // bold
        document.documentElement.style.setProperty('--boldFontName',"'Roboto', sans-serif")
        document.documentElement.style.setProperty('--boldFontUrl',"")
        document.documentElement.style.setProperty('--boldFontUrlsrc',"")
      }

      if(themeData['fonts'].italic && themeData['fonts'].italic.name && themeData['fonts'].italic.url ){
        this.supportUrl(themeData, themeData['fonts'].italic.url, 'italic')
      }else{
        if(document.getElementById('italic')){
          document.getElementById('italic').style.fontFamily = "'Roboto', sans-serif"
          }else{
        injectGlobal`
          #italic {
            font-family: 'Roboto', sans-serif;
          }
        `
      }
        // italic
        document.documentElement.style.setProperty('--italicFontName',"Roboto")
        document.documentElement.style.setProperty('--italicFontUrl',"")
        document.documentElement.style.setProperty('--italicFontUrlsrc',"")
      }

    } else
      this.restoreFonts()
  }

  async supportUrl(themeData,url, type){
    if(url ){
      const incomingURL = new URL(url)
      let hostname = environment.urlHostName
      const isEmulator = environment.useEmulators

      if(incomingURL.protocol=="pass:" ){
        const parts = url.match(/pass:\/\/(.+)\/(.+)/)
        if(parts){
          const passTemplateID = parts[1]
          const path = parts[2]
          let firebaseUrl = `https://${hostname}/v1/pass/${passTemplateID}/${path}`
          if(isEmulator)
            firebaseUrl = `http://localhost:5000/v1/pass/${passTemplateID}/${path}`
          this.urlFonts[url]=firebaseUrl
          this.urlFonts[type]=firebaseUrl
        }else{
          const newparts = url.match(/pass:\/\/(.+)/)
          if(newparts){
            let firebaseUrl = `https://${hostname}/v1/pass/${this.idToShow}`
            if(isEmulator)
              firebaseUrl = `http://localhost:5000/v1/pass/${this.idToShow}`
            newparts.forEach( (part,index)=> {
              if(index>0){
                firebaseUrl += '/' + part
              }
            })
            this.urlFonts[url]=firebaseUrl
            this.urlFonts[type]=firebaseUrl
          }
        }
      }

      if (incomingURL.protocol === "context:") {
        const matchName = url.match(/context:\/\/fonts\/([^/]+)/);
        if (matchName) {
          const fontName = matchName[1];

          if (fontName) {
            try {
              const contextId =  this.settingsService.contextId$
              let firebaseUrl = `https://${hostname}/v1/context/${contextId}/fonts/${fontName}`;
              if(isEmulator)
                firebaseUrl = `http://localhost:5000/v1/context/${contextId}/fonts/${fontName}`;
              this.urlFonts[url] = firebaseUrl;
              this.urlFonts[type] = firebaseUrl;
            } catch (error) {
              console.error('Error retrieving context ID', error);
            }
          }
        } else {
          console.error('Font name could not be extracted from the URL.');
        }
      }

      if(incomingURL.protocol =="tridy:"){
        const parts = url.match(/tridy:\/\/(.+)\/(.+)/)
        let path =""
        parts.forEach((parte, index) =>{
          if(index>0 && index<parts.length){
            path += "/" + parte
          }
        })
        let firebaseUrl = `https://${hostname}/v1/pass${path}`
        if(isEmulator)
          firebaseUrl = `http://localhost:5000/v1/pass${path}`;
        this.urlFonts[type]=firebaseUrl
      }

      if(incomingURL.protocol == "https:" && incomingURL.host == "firebasestorage.googleapis.com"){
        const parts = url.match(/https:\/\/firebasestorage.googleapis.com(.+)/)
        const host = incomingURL.pathname.match(/narravero-eu-dev/)
        const passes = incomingURL.pathname.match(/(.+)passes(.+)/)
        const info = passes[2].split("%2F")
        const passTemplateID = info[1]
        const path = info[2]
        const name = decodeURI(info[2])
        let firebaseUrl = `https://${hostname}/v1/pass/${passTemplateID}/${path}`
        if(isEmulator)
          firebaseUrl = `http://localhost:5000/v1/pass/${passTemplateID}/${path}`
        this.urlFonts[url]=firebaseUrl
        this.urlFonts[type]=firebaseUrl

      }
      this.updateFontsType(themeData,type)
    }
  }
  

  updateFontsType(themeData,type){
    this.commentService.progressSpin.emit(true)
    if(themeData && themeData['fonts']){
      if(type=='title'){
        if(themeData['fonts'].title && themeData['fonts'].title.name && themeData['fonts'].title.url ){
          if(this.urlFonts[themeData['fonts'].title.url] || this.urlFonts[type]){
            document.documentElement.style.setProperty('--titleFontName',themeData['fonts'].title.name)
            document.documentElement.style.setProperty('--titleFontUrl',this.urlFonts['title'])
            document.documentElement.style.setProperty('--titleFontUrlsrc',"url("+this.urlFonts['title']+")")

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].title.name  + ";\
                src: url('" + this.urlFonts['title']  + "');\
            }\
            "));
            document.head.appendChild(newStyle);

            if(document.getElementById('title')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--titleFontName')
              document.getElementById('title').style.fontFamily = vart
              injectGlobal`
                #title {
                  line-height: 110%;
                  font-family:var(--titleFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'titleFontName'};
                src: var(--titleFontUrlsrc);
              }
              #title {
                line-height: 110%;
                font-family: 'titleFontName';
              }`
              document.body.appendChild(sheet);
            }

          }else{
            document.documentElement.style.setProperty('--titleFontName',themeData['fonts'].title.name)
            document.documentElement.style.setProperty('--titleFontUrl',themeData['fonts'].title.url)
            document.documentElement.style.setProperty('--titleFontUrlsrc',"url("+themeData['fonts'].title.url+")")

            if(document.getElementById('title')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--titleFontName')
              document.getElementById('title').style.fontFamily = vart
              injectGlobal`
                #title {
                  line-height: 110%;
                  font-family: var(--titleFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'titleFontName'};
                src: var(--titleFontUrlsrc);
              }
              #title {
                line-height: 110%;
                font-family: 'titleFontName';
              }`
              document.body.appendChild(sheet);
            }

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].title.name  + ";\
                src: url('" + themeData['fonts'].title.url  + "');\
            }\
            "));
            document.head.appendChild(newStyle);
          }
        }
        else{
          if(document.getElementById('title'))
            document.getElementById('title').style.fontFamily = "Roboto"
          injectGlobal`
            #title {
              font-family: 'Roboto', sans-serif;
            }
          `
          // title
          document.documentElement.style.setProperty('--titleFontName',"Roboto")
          document.documentElement.style.setProperty('--titleFontUrl',"")
          document.documentElement.style.setProperty('--titleFontUrlsrc',"")
        }
      }

      if(type=='subtitle'){
        if(themeData['fonts'].subtitle && themeData['fonts'].subtitle.name && themeData['fonts'].subtitle.url ){
          if(this.urlFonts[themeData['fonts'].subtitle.url] || this.urlFonts[type]){
            document.documentElement.style.setProperty('--subtitleFontName',themeData['fonts'].subtitle.name)
            document.documentElement.style.setProperty('--subtitleFontUrl',this.urlFonts['subtitle'])
            document.documentElement.style.setProperty('--subtitleFontUrlsrc',"url("+this.urlFonts['subtitle']+")")

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].subtitle.name  + ";\
                src: url('" + this.urlFonts['subtitle']  + "');\
            }\
            "));
            document.head.appendChild(newStyle);

            if(document.getElementById('subtitle')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--subtitleFontName')
              document.getElementById('subtitle').style.fontFamily = vart
              injectGlobal`
                #subtitle {
                  line-height: 110%;
                  font-family: var(--subtitleFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'subtitleFontName'};
                src: var(--subtitleFontUrlsrc);
              }
              #subtitle {
                line-height: 110%;
                font-family: 'subtitleFontName';
              }`
              document.body.appendChild(sheet);
            }

          }else{
            document.documentElement.style.setProperty('--subtitleFontName',themeData['fonts'].subtitle.name)
            document.documentElement.style.setProperty('--subtitleFontUrl',themeData['fonts'].subtitle.url)
            document.documentElement.style.setProperty('--subtitleFontUrlsrc',"url("+themeData['fonts'].subtitle.url+")")

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("@import url('"+themeData['fonts'].subtitle.url+"');"));
            document.body.appendChild(newStyle)

            if(document.getElementById('subtitle')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--subtitleFontName')
              document.getElementById('subtitle').style.fontFamily = vart
              injectGlobal`
                #subtitle {
                  line-height: 110%;
                  font-family: var(--subtitleFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'subtitleFontName'};
                src: var(--subtitleFontUrlsrc);
              }
              #subtitle {
                line-height: 110%;
                font-family: 'subtitleFontName';
              }`
              document.body.appendChild(sheet);
            }

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].subtitle.name  + ";\
                src: url('" + themeData['fonts'].subtitle.url  + "');\
            }\
            "));
            document.head.appendChild(newStyle);
          }
        }
        else{
          if(document.getElementById('subtitle'))
            document.getElementById('subtitle').style.fontFamily = "Roboto"
          injectGlobal`
            #subtitle {
              line-height: 110%;
              font-family: 'Roboto', sans-serif;
            }
          `
          // subtitle
          document.documentElement.style.setProperty('--subtitleFontName',"Roboto")
          document.documentElement.style.setProperty('--subtitleFontUrl',"")
          document.documentElement.style.setProperty('--subtitleFontUrlsrc',"")
        }
      }

      if(type=='plain'){
        if(themeData['fonts'].plain && themeData['fonts'].plain.name && themeData['fonts'].plain.url ){
          if(this.urlFonts[themeData['fonts'].plain.url] || this.urlFonts[type]){
            document.documentElement.style.setProperty('--plainFontName',themeData['fonts'].plain.name)
            document.documentElement.style.setProperty('--plainFontUrl',this.urlFonts['plain'])
            document.documentElement.style.setProperty('--plainFontUrlsrc',"url("+this.urlFonts['plain']+")")

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].plain.name  + ";\
                src: url('" + this.urlFonts['plain']  + "');\
            }\
            "));
            document.head.appendChild(newStyle);

            if(document.getElementById('plain')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--plainFontName')
              document.getElementById('plain').style.fontFamily = vart
              injectGlobal`
                #plain {
                  line-height: 110%;
                  font-family: var(--plainFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'plainFontName'};
                src: var(--plainFontUrlsrc);
              }
              #plain {
                line-height: 110%;
                font-family: 'plainFontName';
              }`
              document.body.appendChild(sheet);
            }

          }else{
            document.documentElement.style.setProperty('--plainFontName',themeData['fonts'].plain.name)
            document.documentElement.style.setProperty('--plainFontUrl',themeData['fonts'].plain.url)
            document.documentElement.style.setProperty('--plainFontUrlsrc',"url("+themeData['fonts'].plain.url+")")

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("@import url('"+themeData['fonts'].plain.url+"');"));
            document.body.appendChild(newStyle)

            if(document.getElementById('plain')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--plainFontName')
              document.getElementById('plain').style.fontFamily = vart
              injectGlobal`
                #plain {
                  line-height: 110%;
                  font-family: var(--plainFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'plainFontName'};
                src: var(--plainFontUrlsrc);
              }
              #plain {
                line-height: 110%;
                font-family: 'plainFontName';
              }`
              document.body.appendChild(sheet);
            }

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].plain.name  + ";\
                src: url('" + themeData['fonts'].plain.url  + "');\
            }\
            "));
            document.head.appendChild(newStyle);
          }
        }
        else{
          if(document.getElementById('plain'))
            document.getElementById('plain').style.fontFamily = "'Roboto', sans-serif"
          injectGlobal`
            #plain {
              line-height: 110%;
              font-family: 'Roboto', sans-serif;
            }
          `
          // plain
          document.documentElement.style.setProperty('--plainFontName', "'Roboto', sans-serif");
          document.documentElement.style.setProperty('--plainFontUrl',"")
          document.documentElement.style.setProperty('--plainFontUrlsrc',"")
        }
      }

      if(type=='bold'){
        if(themeData['fonts'].bold && themeData['fonts'].bold.name && themeData['fonts'].bold.url ){
          if(this.urlFonts[themeData['fonts'].bold.url] || this.urlFonts[type]){
            document.documentElement.style.setProperty('--boldFontName',themeData['fonts'].bold.name)
            document.documentElement.style.setProperty('--boldFontUrl',this.urlFonts['bold'])
            document.documentElement.style.setProperty('--boldFontUrlsrc',"url("+this.urlFonts['bold']+")")
            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].bold.name  + ";\
                src: url('" + this.urlFonts['bold']  + "');\
            }\
            "));
            document.head.appendChild(newStyle);

            if(document.getElementById('bold')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--boldFontName')
              document.getElementById('bold').style.fontFamily = vart
              injectGlobal`
                #bold {
                  line-height: 110%;
                  font-family:var(--boldFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'boldFontName'};
                src: var(--boldFontUrlsrc);
              }
              #bold {
                line-height: 110%;
                font-family: 'boldFontName';
              }`
              document.body.appendChild(sheet);
            }

          }else{
            document.documentElement.style.setProperty('--boldFontName',themeData['fonts'].bold.name)
            document.documentElement.style.setProperty('--boldFontUrl',themeData['fonts'].bold.url)
            document.documentElement.style.setProperty('--boldFontUrlsrc',"url("+themeData['fonts'].bold.url+")")

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("@import url('"+themeData['fonts'].bold.url+"');"));
            document.body.appendChild(newStyle)

            if(document.getElementById('bold')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--boldFontName')
              document.getElementById('bold').style.fontFamily = vart
              injectGlobal`
                #bold {
                  line-height: 110%;
                  font-family: var(--boldFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'boldFontName'};
                src: var(--boldFontUrlsrc);
              }
              #bold {
                line-height: 110%;
                font-family: 'boldFontName';
              }`
              document.body.appendChild(sheet);
            }

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].bold.name  + ";\
                src: url('" + themeData['fonts'].bold.url  + "');\
            }\
            "));
            document.head.appendChild(newStyle);
          }
        }
        else{
          if(document.getElementById('bold'))
            document.getElementById('bold').style.fontFamily = "'Roboto', sans-serif"
          injectGlobal`
            #bold {
              line-height: 110%;
              font-family: 'Roboto', sans-serif;
            }
          `
          // bold
          document.documentElement.style.setProperty('--boldFontName',"'Roboto', sans-serif")
          document.documentElement.style.setProperty('--boldFontUrl',"")
          document.documentElement.style.setProperty('--boldFontUrlsrc',"")
        }
      }

      if(type=='italic'){
        if(themeData['fonts'].italic && themeData['fonts'].italic.name && themeData['fonts'].italic.url ){
          if(this.urlFonts[themeData['fonts'].italic.url] || this.urlFonts[type]){
            document.documentElement.style.setProperty('--italicFontName',themeData['fonts'].italic.name)
            document.documentElement.style.setProperty('--italicFontUrl',this.urlFonts['italic'])
            document.documentElement.style.setProperty('--italicFontUrlsrc',"url("+this.urlFonts['italic']+")")

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].italic.name  + ";\
                src: url('" + this.urlFonts['italic']  + "');\
            }\
            "));
            document.head.appendChild(newStyle);

            if(document.getElementById('italic')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--italicFontName')
              document.getElementById('italic').style.fontFamily = vart
              injectGlobal`
                #italic {
                  line-height: 110%;
                  font-family: var(--italicFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'italicFontName'};
                src: var(--italicFontUrlsrc);
              }
              #italic {
                line-height: 110%;
                font-family: 'italicFontName';
              }`
              document.body.appendChild(sheet);
            }

          }else{
            document.documentElement.style.setProperty('--italicFontName',themeData['fonts'].italic.name)
            document.documentElement.style.setProperty('--italicFontUrl',themeData['fonts'].italic.url)
            document.documentElement.style.setProperty('--italicFontUrlsrc',"url("+themeData['fonts'].italic.url+")")

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("@import url('"+themeData['fonts'].italic.url+"');"));
            document.body.appendChild(newStyle)

            if(document.getElementById('italic')){
              const vart = getComputedStyle(document.documentElement).getPropertyValue('--italicFontName')
              document.getElementById('italic').style.fontFamily = vart
              injectGlobal`
                #italic {
                  line-height: 110%;
                  font-family: var(--italicFontName);
                }
              `
            }else{
              var sheet = document.createElement('style')
              sheet.innerHTML = ` @font-face {
                font-family: 'italicFontName'};
                src: var(--italicFontUrlsrc);
              }
              #italic {
                line-height: 110%;
                font-family: 'italicFontName';
              }`
              document.body.appendChild(sheet);
            }

            var newStyle = document.createElement('style');
            newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + themeData['fonts'].italic.name  + ";\
                src: url('" + themeData['fonts'].italic.url  + "');\
            }\
            "));
            document.head.appendChild(newStyle);
          }
        }
        else{
          if(document.getElementById('italic'))
            document.getElementById('italic').style.fontFamily = "Roboto"
          injectGlobal`
            #italic {
              line-height: 110%;
              font-family: 'Roboto', sans-serif;
            }
          `
          // italic
          document.documentElement.style.setProperty('--italicFontName',"Roboto")
          document.documentElement.style.setProperty('--italicFontUrl',"")
          document.documentElement.style.setProperty('--italicFontUrlsrc',"")
        }
      }
      this.commentService.progressSpin.emit(false)
    }
  }

  setIdToShow(idToShow){
    this.idToShow = idToShow
  }
}
